import { DealershipListQuery } from '~/graphql/types'
import { FormData } from '../..'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import { useCallback } from 'react'
import { Box, Divider, Typography, useTheme } from '@mui/material'
import { Button } from '~/components/Form/Button'
import { IconPercentage, IconPlus, IconTrash, IconX } from '@tabler/icons-react'
import { Input } from '~/components/Form/Input'
import { confirmDialog } from '~/components'
import { SelectMultiple } from '~/components/Form/SelectMultiple'
import { Option } from '~/utils/options'
import { Container, SelectComissionItem } from './styles'

type InitialComissionExceptionProps = {
  dealerships: DealershipListQuery['dealershipList']['data']
}

export type InitialComissionExceptionData = {
  dealerships: string[]
  baseCommissionPercentage?: number
  commissionedInvoices?: number
  id?: string
}

export const InitialComissionException: React.FC<InitialComissionExceptionProps> = ({ dealerships }) => {
  const theme = useTheme()
  const formMethods = useFormContext<FormData>()
  const { anticipated } = useWatch({ control: formMethods.control })
  const { fields, append, remove } = useFieldArray({ control: formMethods.control, name: 'anticipated.initialCommissionExceptionData' })

  const onAddComissionException = useCallback(() => {
    append({
      dealerships: [],
    })
  }, [])

  const onRemoveComissionException = useCallback(async (index: number) => {
    
    const isConfirmed = await confirmDialog({
      title: 'Remover concessionária com exceção de benefício',
      type: 'warning',
      proccedText: 'Sim, desejo remover',
      content: <Box>
        <>
          <p>Tem certeza de que deseja remover o grupo de exceção <b>{index + 1}</b>?</p>
        </>
      </Box>
    })

    if (isConfirmed) {
      remove(index)
    }

  }, [])

  const onRemoveDealership = useCallback((dealershipId: string, index: number) => {
    formMethods.setValue(`anticipated.initialCommissionExceptionData.${index}.dealerships`, anticipated?.initialCommissionExceptionData?.[index]?.dealerships?.filter(item => item !== dealershipId) || [])
  }, [anticipated])

  const formatDealershipsToSelect = (myDealerships: DealershipListQuery['dealershipList']['data']): Option[] => {
    return myDealerships.map(item => ({ label: item.name || '', value: item._id }))
  }

  return (
    <Container>
      {fields.map((field, index) => {

        const filteredDealerships = dealerships.filter(item => !anticipated?.initialCommissionExceptionData?.flatMap(detail => detail.dealerships).includes(item._id)) || dealerships

        const FORMATED_DEALERSHIPS = formatDealershipsToSelect(filteredDealerships)

        return (
          <Box className='item' key={field.id}>
            <Box  sx={{ display: 'flex', alignItems: 'center', gap: '.8rem', padding: '0 0 1.2rem 0' }}>
              {anticipated?.initialCommissionExceptionData?.[index]?.dealerships?.map(item => (
                <SelectComissionItem key={item}>
                  {dealerships.find(dealership => dealership._id === item)?.name}
                  <button onClick={() => onRemoveDealership(item, index)}>
                    <IconX color={theme.palette.error.main} />
                  </button>
                </SelectComissionItem>
              ))}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
              <Box sx={{
                width: '24px',
                height: '24px',
                borderRadius: '4px',
                background: theme.palette.info.dark,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.palette.common.white,
                fontSize: '.9rem'
              }}>
                {index + 1}°
              </Box>
              <Typography sx={{ fontSize: '.9rem', fontWeight: 500, color: theme.palette.grey[800] }}>Grupo</Typography>
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', padding: '1.2rem 0' }}>
              <SelectMultiple searchable label='Concessionária' name={`anticipated.initialCommissionExceptionData.${index}.dealerships`} options={FORMATED_DEALERSHIPS} />
              <Input icons={{ end: { element: <IconPercentage /> } }} mask='percentage' label='Percentual de comissão do grupo' name={`anticipated.initialCommissionExceptionData.${index}.baseCommissionPercentage`} />
              <Input label='Número de parcelas' name={`anticipated.initialCommissionExceptionData.${index}.commissionedInvoices`} />
            </Box>

            <Divider sx={{ margin: '0 0 1.2rem 0' }} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}>
              <Button 
                startIcon={<IconTrash />} 
                variant='outlined'
                sx={{ '&:hover': { borderWidth: '2px' } }} 
                color='error'
                onClick={() => onRemoveComissionException(index)}
              >
                Remover grupo
              </Button>
            </Box>
          </Box>
        )
      })}

      {/* BOTOES DE ADICIONAR E REMOVER GRUPO */}

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
        <Button 
          startIcon={<IconPlus />} 
          color='secondary'
          onClick={() => onAddComissionException()}
        >
          Adicionar grupo
        </Button>
      </Box>
    </Container>
  )
}
